import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import GlobalStyle from './lib/style/GlobalStyle';
import { ThemeProvider } from 'styled-components';
import ThemeStyle from './lib/style/ThemeStyle';

import * as serviceWorker from './serviceWorker';
import Root from './Root';
import { BrowserTracing } from '../node_modules/@sentry/tracing/dist/index';

Sentry.init({
  environment: process.env.NODE_ENV,
  dsn:
    process.env.NODE_ENV === 'production'
      ? process.env.REACT_APP_SENTRY_DSN
      : false,
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
});

ReactDOM.render(
  <>
    <GlobalStyle />
    <ThemeProvider theme={ThemeStyle}>
      <Root />
    </ThemeProvider>
  </>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
